//#Global Imports
import React from "react";
import clsx from "clsx";
import moment from "moment";
//#end Global Imports

//#Local Imports
import ErrorField from "../../../../components/ui/ErrorField";
import TextField from "../../../../components/ui/TextField";
import Button from "../../../../components/ui/Button";
import { PassportIcon, ReloadIcon, UploadIcon } from "../../../../assets/Icons";
import IUserDocuments from "../../userDocuments";
import { DatePicker } from "../../../../components/ui/DatePicker";
//#end Local Imports

const IndianPassportSection: React.FC<IUserDocuments.IIndianPassportSectionProps> = ({
  passportDetails,
  handleDeleteDoc,
  handleChangeUpload,
  handlePassportBackVerification,
  handlePassportVerification,
  setPassportDetails,
  handlePassportDobChangeHandler,
  docDob,
  buttonLoader,
}) => {
  const passportDobValue = docDob || passportDetails.passportDob;
  const convertedDate = passportDobValue
    ? moment(passportDobValue, "DD/MM/YYYY").toDate()
    : new Date();
  const maxDate = moment(new Date()).format("YYYY-MM-DD").toString();
  const specialCharRegExp = "[a-zA-Z0-9 ]{1,}";

  return (
    <div className="col-span-4 lg:pl-10 lg:pt-7">
      <div>
        <div className="mb-5 text-base font-medium text-black font-lato">
          Upload Passport<span className="text-error">*</span>
        </div>
        <div className="relative">
          <div className="flex items-center space-x-8">
            <Button
              bgColor="bg-transparent"
              fontStyle={{
                fontFamily: "",
                fontSize: "text-sm",
                fontWeight: "font-normal ",
                fontColor: "text-black-200",
              }}
              borderStyle={{
                borderWidth: "border",
                borderColor: `${
                  passportDetails.isPassportDocVerified || passportDetails.isPassportDocUploaded
                    ? "border-success-150"
                    : "border-grey-150"
                }`,
                borderRadius: "rounded",
              }}
              className="w-full lg:!w-[48%] mb-5 h-[68px]"
            >
              <div className="flex items-center justify-between w-full px-4 lg:px-6">
                <div className="flex items-center space-x-2 lg:space-x-6">
                  <PassportIcon
                    width="23px"
                    height="29px"
                    fillColor={
                      passportDetails.isPassportDocVerified || passportDetails.isPassportDocUploaded
                        ? "fill-success-150"
                        : "fill-primary"
                    }
                  />
                  <div>Upload passport front page</div>
                </div>
                <div className="flex items-center space-x-2">
                  {!passportDetails.isPassportDocVerified &&
                    (passportDetails.isPassportDocUploaded ? (
                      <div
                        onClick={
                          !passportDetails.isPassportDocVerified &&
                          passportDetails.isPassportDocUploaded
                            ? handleDeleteDoc
                            : () => ""
                        }
                        className="z-50 cursor-pointer"
                      >
                        <ReloadIcon fillColor="fill-success-150" width="24" height="24" />
                      </div>
                    ) : (
                      <UploadIcon fillColor="fill-secondary-600" />
                    ))}
                </div>
              </div>
            </Button>
          </div>
          {(passportDetails.uploadedFrontDocError !== "" ||
            passportDetails.messagePassport !== "") && (
            <ErrorField
              errorMessage={
                passportDetails.isPassportDocUploaded
                  ? passportDetails.messagePassport
                  : passportDetails.uploadedFrontDocError
              }
            />
          )}
          <form encType="multipart/form-data" action="">
            <TextField
              accept="image/*,application/pdf"
              name="passportFront"
              type="file"
              disabled={passportDetails.isPassportDocUploaded}
              rootClassName="absolute top-0 opacity-0 !w-full lg:!w-[48%]"
              onChange={(e) => handleChangeUpload(e, "PASSPORT_FRONT")}
              onClick={(event) => {
                event.currentTarget.value = "";
              }}
            />
          </form>
        </div>
        <div className="relative">
          <div className="flex items-center space-x-8">
            <Button
              bgColor="bg-transparent"
              fontStyle={{
                fontFamily: "",
                fontSize: "text-sm",
                fontWeight: "font-normal ",
                fontColor: "text-black-200",
              }}
              borderStyle={{
                borderWidth: "border",
                borderColor: `${
                  passportDetails.isPassportBackDocVerified ||
                  passportDetails.isPassportBackUploaded
                    ? "border-success-150"
                    : "border-grey-150"
                }`,
                borderRadius: "rounded",
              }}
              className="w-full mb-5 h-[68px] lg:!w-[48%]"
            >
              <div className="flex items-center justify-between w-full px-4 lg:px-6">
                <div className="flex items-center space-x-2 lg:space-x-6">
                  <PassportIcon
                    width="23px"
                    height="29px"
                    fillColor={
                      passportDetails.isPassportBackDocVerified ||
                      passportDetails.isPassportBackUploaded
                        ? "fill-success-150"
                        : "fill-primary"
                    }
                  />
                  <div>Upload passport back page</div>
                </div>
                <div className="flex items-center space-x-2">
                  {!passportDetails.isPassportBackDocVerified &&
                    (passportDetails.isPassportBackUploaded ? (
                      <div
                        onClick={
                          !passportDetails.isPassportBackDocVerified &&
                          passportDetails.isPassportBackUploaded
                            ? handleDeleteDoc
                            : () => ""
                        }
                        className="z-50 cursor-pointer"
                      >
                        <ReloadIcon fillColor="fill-success-150" width="24" height="24" />
                      </div>
                    ) : (
                      <UploadIcon fillColor="fill-secondary-600" />
                    ))}
                </div>
              </div>
            </Button>
          </div>
          {(passportDetails.uploadedBackDocError !== "" ||
            passportDetails.messageBackPassport !== "") && (
            <ErrorField
              errorMessage={
                passportDetails.isPassportBackUploaded
                  ? passportDetails.messageBackPassport
                  : passportDetails.uploadedBackDocError
              }
            />
          )}
          <form encType="multipart/form-data" action="">
            <TextField
              accept="image/*,application/pdf"
              name="passportBack"
              type="file"
              rootClassName="absolute top-0 opacity-0 lg:!w-[48%] !w-full"
              disabled={
                passportDetails.isPassportBackUploaded || !passportDetails.isPassportDocUploaded
              }
              onChange={(e) => handleChangeUpload(e, "PASSPORT_BACK")}
              onClick={(event) => {
                event.currentTarget.value = "";
              }}
            />
          </form>
        </div>
        <div className="mb-5 text-base font-medium text-black font-lato">
          Passport no.<span className="text-error">*</span>
        </div>
        <TextField
          name="passportIdNumber"
          type="text"
          placeholderStyle="!text-primary-850"
          inputClasses={clsx(
            passportDetails?.isPassportDocVerified && passportDetails?.isPassportBackDocVerified
              ? "border-success-150"
              : "border-grey-150",
            `border !pt-1 lg:!w-[48%]`
          )}
          value={passportDetails.passportIdNumber}
          onChange={(event) =>
            setPassportDetails((preValue: any) => {
              return {
                ...preValue,
                passportIdNumber: event.target.value,
              };
            })
          }
          disabled={!passportDetails?.isPassportDocUploaded}
          fullWidth
          pattern={specialCharRegExp}
        />
        {passportDetails.isPassportDocUploaded && !passportDetails.isPassportBackDocVerified && (
          <div className="flex flex-col items-start w-full space-x-8 lg:items-start lg:flex-row">
            <div className="w-full">
              <div className="mb-5 text-base font-medium text-black font-lato">
                Passport file no.<span className="text-error">*</span>
              </div>
              <TextField
                type="text"
                fullWidth
                name="passportFileNumber"
                placeholderStyle="!text-primary-850"
                inputClasses={clsx(
                  passportDetails?.isPassportBackDocVerified
                    ? "border-success-150"
                    : "border-grey-150",
                  `border !pt-1 lg:!w-full`
                )}
                value={passportDetails.passportBackIdNumber}
                onChange={(event) =>
                  setPassportDetails((preValue: any) => {
                    return {
                      ...preValue,
                      passportBackIdNumber: event.target.value,
                    };
                  })
                }
                pattern={specialCharRegExp}
              />
            </div>
            <div className="w-full">
              <div className="mb-5 text-base font-medium text-black font-lato">
                DOB as per passport
              </div>
              <DatePicker
                selectedDate={
                  passportDobValue === ""
                    ? new Date().toString()
                    : moment(convertedDate).format("YYYY-MM-DD")
                }
                dateChangeHandler={handlePassportDobChangeHandler}
                datepickerClassname="bg-transparent !p-4 !rounded border !border-grey-150 lg:w-[300px]"
                disabled={passportDetails?.isPassportBackDocVerified}
                maxDate={maxDate}
              />
            </div>
          </div>
        )}
        {!passportDetails.isPassportDocVerified ? (
          <Button
            bgColor={passportDetails?.isPassportDocUploaded ? "bg-primary" : "bg-grey-350"}
            fontStyle={{
              fontFamily: "",
              fontSize: "text-base",
              fontWeight: "font-bold",
              fontColor: "text-white",
            }}
            borderStyle={{
              borderWidth: "border",
              borderColor: passportDetails?.isPassportDocUploaded
                ? "border-primary"
                : "border-grey-350",
              borderRadius: "rounded",
            }}
            className={"py-5 w-full mt-9 lg:!w-[48%]"}
            disabled={!passportDetails?.isPassportDocUploaded}
            onClickHandler={handlePassportVerification}
            isLoading={buttonLoader.passportVerificationLoader}
          >
            Verify Passport Front
          </Button>
        ) : (
          !passportDetails.isPassportBackDocVerified &&
          passportDetails.isPassportDocVerified && (
            <Button
              bgColor={
                passportDetails?.isPassportBackUploaded &&
                passportDetails.passportBackIdNumber !== ""
                  ? "bg-primary"
                  : "bg-grey-350"
              }
              fontStyle={{
                fontFamily: "",
                fontSize: "text-base",
                fontWeight: "font-bold",
                fontColor: "text-white",
              }}
              borderStyle={{
                borderWidth: "border",
                borderColor:
                  passportDetails?.isPassportBackUploaded &&
                  passportDetails.passportBackIdNumber !== ""
                    ? "border-primary"
                    : "border-grey-350",
                borderRadius: "rounded",
              }}
              className={"py-5 w-full mt-9 lg:!w-[48%]"}
              disabled={
                !passportDetails?.isPassportBackUploaded ||
                passportDetails.passportBackIdNumber === ""
              }
              onClickHandler={handlePassportBackVerification}
              isLoading={buttonLoader.passportBackVerificationLoader}
            >
              Verify Passport Back
            </Button>
          )
        )}
      </div>
    </div>
  );
};

export default IndianPassportSection;
